/* ===========================
   Botón Volver Arriba - VIKANI
   =========================== */

document.addEventListener("DOMContentLoaded", function() {
  const backToTop = document.getElementById("back-to-top");

  // Escucha el scroll de la página
  window.addEventListener("scroll", function() {
    if (window.scrollY >500) {
      backToTop.style.display = "block"; // aparece después de 200px
    } else {
      backToTop.style.display = "none"; // oculto al inicio
    }
  });
});
